const QUOTES = [
  {
    title: "RizkiOS",
    subtitle: "Life's too short to wait for the perfect moment. Take the moment and make it perfect.",
  },
  {
    title: "Hello",
    subtitle: "Seek knowledge from the cradle to the grave",
  },
  {
    title: "Smile",
    subtitle: "It's the easiest charity",
  },
  {
    title: "Welcome",
    subtitle: "Peace be upon you",
  },
];

export default QUOTES;
